// extracted by mini-css-extract-plugin
export default {"no-results":"i6OAdkvgecuxhjHCFZXo"};